import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const ObjectiveHeader = styled.div`
  padding-top: 30px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
`;

export const PageEditContainer = styled.div`
  display: flex;
  ${media.tablet`
    flex-direction: column;
  `}
`;

export const MarginContainer = styled.div`
  margin-top: 80px;
`;
